module.exports = __webpack_public_path__ + "img/Header4.e656acc0.jpg";